$(document).on('ready page:load', () => {
  const storeVisitorKey = (key) => {
    if (key === null || (window as any).$.cookie('wistiaVisitorKey') === key) {
      return
    }

    $.ajax({
      url: '/api/v1/wistia_visitors',
      data: { visitor_key: (window as any).visitorKey },
      method: 'POST',
      headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') },
    }).always(() => (window as any).$.cookie('wistiaVisitorKey', key))
  }

  if (wistiaGuard((window as any).currentUser(), (x) => x.id)) {
    const visitorKey = (window as any).Wistia.visitorKey.value()
    if (visitorKey) {
      storeVisitorKey(visitorKey)
    }
  }
})

function wistiaGuard(value, transform) {
  return typeof value !== 'undefined' && value !== null
    ? transform(value)
    : undefined
}
